import { render } from "./BoatBooking.vue?vue&type=template&id=63918f8d&scoped=true"
import script from "./BoatBooking.vue?vue&type=script&lang=js"
export * from "./BoatBooking.vue?vue&type=script&lang=js"

import "./BoatBooking.vue?vue&type=style&index=0&id=63918f8d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63918f8d"

export default script